/* @jsx jsx */
import { css } from "@emotion/core";

// const LIGHT_GREEN = "#D6DEDD";
const BORDER_RADIUS = ".7rem";
const LIGHT_GREY = "#f8f8f8";

const getStyles = customColor => {
  const primaryColor = customColor || "#3B8163"; // color from settings or (MINT_ALTOID_GREEN #5EB58F) made darker to up contrast to 31 #4CA47E"

  return css`
    .reco-filter {
      text-align: center;
      margin-bottom: 1em;
      font-weight: 120;
    }

    .reco-stats {
      background: ${LIGHT_GREY};
      border-radius: ${BORDER_RADIUS};
      padding: 2rem 2rem !important;
    }

    .reco-stat {
      text-align: left;
      font-size: 100%;

      .reco-stat-body {
        padding: 1rem;
        border-radius: ${BORDER_RADIUS};
        background: #fff;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
      }

      h4 {
        color: ${primaryColor};
        font-size: 2rem;
        margin: 0;
        padding: 0;
        font-weight: 200;
      }

      h5 {
        font-size: 1em;
        font-weight: 800;
        line-height: 1;
        text-transform: uppercase;
        margin: 0.6rem 0 0 0;
        padding: 0;
        color: #666;
      }
    }

    .reco-nav {
      text-align: center;

      .button {
        border: 1px solid ${primaryColor};
        background-color: transparent;
        color: ${primaryColor};
        text-align: center;
        font-size: 1.2rem;
        display: inline-block;

        &.active,
        &:hover {
          border: none;
          color: #fff !important;
          background: ${primaryColor} !important;
          border: 1px solid ${primaryColor} !important;
        }
      }
    }

    .reco-detailed-stats {
      margin-top: 2rem;
      margin-bottom: 2rem;
    }

    .reco-detailed-stats-feature {
      background: ${LIGHT_GREY};
      padding: 2rem 0 4rem 0 !important;
      margin-top: 2rem;
    }

    .reco-detailed-stats-feature-chart {
      height: 350px;
    }

    .reco-detailed-stats-sub-visual {
      height: 300px;
      margin: 2rem 0;
    }

    .recommendations-table {
      margin-top: 2em;
      width: 100%;
    }

    @media only screen and (max-width: 991px) {
      .recommendations-table .break-word-narrow {
        word-break: break-word;
      }
    }

    .reco-detailed-stats-header {
      margin: 2rem 0;

      h3 {
        color: ${primaryColor} !important;
        margin: 0 !important;
      }
    }

    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border-width: 0;
    }
  `;
};

export default getStyles;
